import { atom } from "jotai";

// Shared loading state atoms for navigation actions
export const saveDesignLoadingAtom = atom(false);
export const addToCartLoadingAtom = atom(false);
export const shopifyRecipeLoadingAtom = atom(false);
